// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore'; // For Firestore
import { getAuth } from 'firebase/auth'; // For Authentication

const firebaseConfig = {
  apiKey: "AIzaSyDixrbIzx1IPowcVaGMtWG6SMHS-eWVSR4",
  authDomain: "theater-seat-logger.firebaseapp.com",
  databaseURL: "https://theater-seat-logger-default-rtdb.firebaseio.com",
  projectId: "theater-seat-logger",
  storageBucket: "theater-seat-logger.appspot.com",
  messagingSenderId: "301134426305",
  appId: "1:301134426305:web:11bc5ce0b849493695e440",
  measurementId: "G-Z11DPT9Z8E"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Firebase Authentication
export const auth = getAuth(app);
